import * as React from 'react';
import { Component } from 'react';

export class Accessibility extends Component {
    constructor(props) {
        super(props);

        this.toggleContrast = this.toggleContrast.bind(this);
        this.makeFontBigger = this.makeFontBigger.bind(this);
        this.makeFontSmaller = this.makeFontSmaller.bind(this);
    }

    public render() {
        return (
            <div className="accessibility menu-dropdown menu-dropdown-main">
                <span className="accessibility-btn contrast-btn" onClick={this.toggleContrast} />
                <span className="accessibility-btn" onClick={this.makeFontSmaller}>A</span>
                <span className="accessibility-btn bigfont-btn" onClick={this.makeFontBigger}>A</span>
            </div>
        );
    }

    private toggleContrast(evt) {
        document.documentElement.classList.toggle('contrast');
    }

    private makeFontBigger(evt) {
        document.documentElement.classList.add('bigger-font');
    }

    private makeFontSmaller(evt) {
        document.documentElement.classList.remove('bigger-font');
    }    
}


// WEBPACK FOOTER //
// ./src/components/NavMenu/Accessibility.tsx